import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Translate from 'react-translate-component';
import { withAsyncActions } from 'react-async-client';
import { Row, Col } from 'antd';

import { getTrainerEvents } from 'actions/asyncActions';
import { fullAutoOptions } from 'constants/asyncClient';
import StaticTable from 'components/common/tableComponents/StaticTable';
import RefreshButton from 'components/common/controls/RefreshButton';
import DropdownStatusFilter from 'components/common/controls/DropdownStatusFilter';
import { trainerTimetable } from 'constants/routes';

@withAsyncActions({
    getTrainerEvents: getTrainerEvents.withDefaultPayload(({ filters }) => filters)
}, fullAutoOptions)
export default class TrainerEventsTable extends Component {
    static propTypes = {
        getTrainerEvents: PropTypes.object.isRequired,
        onFiltersChange: PropTypes.func.isRequired,
        filters: PropTypes.object.isRequired,
        defaultFilters: PropTypes.object.isRequired,
    }

    tableColumns = [
        {
            name: 'number',
            width: 60,
            template: ({ rowIndex }) => rowIndex + 1,
            additionalClass: 'p-l-15',
        },
        {
            name: 'courseName',
            label: <Translate content="education.trainer.course" />,
            template: ({ item: { courseName = [] } }) => courseName.map(courseItem => (
                <div key={courseItem.id}>
                    <Link to={trainerTimetable.stringify({ project: courseItem.id })}>
                        {courseItem.text}
                    </Link>
                </div>
            ))
        },
        {
            name: 'responsible',
            label: <Translate content="education.trainer.responsible" />,
            template: ({ item: { responsible = [] } }) => responsible.map(item => (
                <div key={item.id}>{item.text}</div>
            ))
        },
        {
            name: 'participantsNumber',
            dataIndex: 'participantsNumber',
            label: <Translate content="education.trainer.participantsNumber" />,
            template: ({ item: { participantsNumber } }) => <span>{participantsNumber}</span>
        }
    ]

    render() {
        const { filters, defaultFilters, onFiltersChange } = this.props;
        const { data, meta, refresh } = this.props.getTrainerEvents;

        return (
            <div>
                <Row className="react-table-controls list-controls">
                    <Col offset={18} span={6} className="text-right icon-bar">
                        <DropdownStatusFilter
                            filters={filters}
                            defaultFilters={defaultFilters}
                            onFiltersChange={onFiltersChange}
                            translation="filterStatus.trainer."
                        />
                        <RefreshButton refreshMeta={meta} handleRefresh={refresh} />
                    </Col>
                </Row>
                <StaticTable
                    meta={meta}
                    refresh={refresh}
                    className="width-auto-table"
                    columns={this.tableColumns}
                    items={data}
                />
            </div>
        );
    }
}
